import Api from "~/service/Api";

class CustomerPaymentMethodRepository {
  fetch() {
    return Api.get("/customer/payment-methods");
  }
}

export default CustomerPaymentMethodRepository;
